import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RestApiService, PaginatedResponse } from "./rest-api.service";
import { Company, Project, Site, User } from "../models/base.model";

// The user's interface language (saved in their profile) and the languages offered
export interface UserLanguage {
    language: string;
    options: { id: string; label: string }[];
}

@Injectable({
    providedIn: 'root'
})
export class ApiMeService extends RestApiService {

    public apiGetLanguage(): Observable<UserLanguage> {
        return this.getRaw('me/language/');
    }

    public apiPostLanguage(language: string): Observable<UserLanguage> {
        return this.postRaw('me/language/', { language });
    }


    /**
     * Get current authenticated user profile
     */
    public apiGetMe(params: any): Observable<User> {
        return this.getSingle('me/', User.parse, params);
    }

    /**
     * Update current authenticated user profile
     */
    public apiPostMe(payload: any, params: any): Observable<User> {
        return this.postSingle('me/', payload, User.parse, params);
    }

    /**
     * Update user password
     */
    public apiPostPassword(payload: any, params: any): Observable<User> {
        return this.postSingle('me/password/', payload, User.parse, params);
    }

    /**
     * Delete user account
     */
    public apiDeleteMe(payload: any, params: any): Observable<any> {
        return this.postRaw('me/delete', payload, params);
    }

    /**
     * Get paginated list of sites for current user
     */
    public apiGetMySites(params: any): Observable<PaginatedResponse<Site>> {
        return this.getList('me/sites/', Site.parse, params);
    }

    /**
     * Get paginated list of companies for current user
     */
    public apiGetMyCompanies(params: any): Observable<PaginatedResponse<Company>> {
        return this.getList('me/companies/', Company.parse, params);
    }

    /**
     * Get paginated list of projects user has attended
     */
    public apiGetAttendedProjects(params: any): Observable<PaginatedResponse<Project>> {
        return this.getList('me/attended-projects/', Project.parse, params);
    }
}
